export default __webpack_public_path__ + "static/media/wg_white.bc784dd8.png";